/* MotoWing: alt bölüm paketi (motowing-wa, motowing-qv, motowing-tabbar, motowing-catnav snippetlerinden taşındı; her sayfada önbelleğe alınır) */
try{(function(){
  var cn=document.querySelector('[data-mw-cn]'); if(!cn||window.mwCat) return;
  var root=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/').replace(/\/$/,''), body=cn.querySelector('[data-mw-cn-body]'), st=0, last=null;
  var IC={
    moto:'<circle cx="5.5" cy="16.5" r="3.5"/><circle cx="18.5" cy="16.5" r="3.5"/><path d="M5.5 16.5 9 10h5.5l4 6.5"/><path d="M9 10 7.6 7.2H5"/><path d="M14.5 10l1.6-3H19"/><path d="M10.5 13.5h4"/>',
    kask:'<path d="M3.5 15.5C3.5 9.6 7.9 5 13.4 5c4.4 0 7.1 3.2 7.1 7.3v3.9a1.8 1.8 0 0 1-1.8 1.8H5.3a1.8 1.8 0 0 1-1.8-1.8z"/><path d="M11.5 10H20.4"/><path d="M11.5 10v4.5h9"/><path d="M6.5 18v-2.5"/>',
    koruma:'<path d="M2.8 11.6c1.6 0 2.7-.9 4.2-.9h10c1.5 0 2.6.9 4.2.9"/><path d="M7.6 10.7 6.4 6.6"/><path d="M16.4 10.7l1.2-4.1"/><ellipse cx="5.6" cy="5" rx="2.2" ry="1.7"/><ellipse cx="18.4" cy="5" rx="2.2" ry="1.7"/><path d="M9.5 10.7v3.2M14.5 10.7v3.2"/><circle cx="12" cy="17" r="3.4"/><circle cx="12" cy="17" r="1.1"/>',
    parca:'<path d="M6.5 3.5h11a1 1 0 0 1 1 1v6.2a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1z"/><path d="M5.5 6.2h13"/><circle cx="12" cy="9" r="1"/><path d="M10.6 11.7l.7 5.4M13.4 11.7l-.7 5.4"/><circle cx="12" cy="19" r="2.2"/>',
    ithal:'<g transform="rotate(45 12 12)"><path d="M12 2.6c.8 0 1.4.8 1.4 1.9V9l7 4.1v1.9l-7-2v4.4l2.1 1.6v1.6L12 19.8l-3.5.8V19l2.1-1.6V13l-7 2v-1.9l7-4.1V4.5c0-1.1.6-1.9 1.4-1.9z"/></g>',
    altai:'<circle cx="5.8" cy="17.5" r="2.6"/><circle cx="18.4" cy="17.5" r="2.6"/><path d="M3.2 16.3c.4-3 2.5-4.8 5.4-4.8h3.2l1.4 2.5"/><path d="M8.4 17.5h6.9l2.9-10.3"/><path d="M16.3 6.4h3.9"/><path d="M5.6 11.5V9.2h5.2"/>',
    user:'<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/>',
    all:'<rect x="4" y="4" width="6.5" height="6.5" rx="1.6"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.6"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.6"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.6"/>'
  };
  function svg(k){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'+(IC[k]||IC.all)+'</svg>'; }
  /* Başlık kaydırmayla gizlendiyse önce göster, sonra tıkla (temanın menüsü / arama penceresi başlığın içinde açılır) */
  function viaHeader(el){
    var hd=document.querySelector('.section-header'), sh=document.querySelector('sticky-header');
    if(hd&&sh&&typeof sh.reveal==='function'&&(hd.classList.contains('shopify-section-header-hidden')||0>=hd.getBoundingClientRect().bottom)){ sh.reveal(); setTimeout(function(){ el.click(); },220); }
    else el.click();
  }
  function themeMenu(){ var sm=document.querySelector('#Details-menu-drawer-container > summary'); if(sm&&sm.offsetParent!==null) viaHeader(sm); else window.location.href=root+'/collections'; }
  function load(){
    if(st) return; st=1;
    fetch(root+'/collections/all?view=mw-cats',{credentials:'same-origin'})
      .then(function(r){ if(!r.ok) throw 0; return r.text(); })
      .then(function(h){
        if(h.indexOf('mw-cn__rail')===-1) throw 0;
        body.innerHTML=h; st=2; wire();
      })
      .catch(function(){ st=0; if(!cn.hidden){ close(true); themeMenu(); } });
  }
  function wire(){
    [].forEach.call(body.querySelectorAll('[data-ic]'),function(x){ x.innerHTML=svg(x.getAttribute('data-ic')); });
    var tabs=body.querySelectorAll('[data-mw-cn-tab]'), panes=body.querySelectorAll('.mw-cn__pane');
    [].forEach.call(tabs,function(t){
      t.addEventListener('click',function(){
        var i=+t.getAttribute('data-mw-cn-tab');
        [].forEach.call(tabs,function(x,k){ var on=k===i; x.classList.toggle('is-on',on); x.setAttribute('aria-selected',on?'true':'false'); });
        [].forEach.call(panes,function(p,k){ p.hidden=k!==i; });
        var pw=body.querySelector('.mw-cn__panes'); if(pw) pw.scrollTop=0;
      });
    });
    /* Garajım kartı: kayıtlı motor */
    var g=body.querySelector('[data-mw-cn-gar]');
    if(g){
      g.querySelector('.mw-cn__gi').innerHTML=svg('moto');
      var s=null; try{ s=JSON.parse(localStorage.getItem('mw_moto')||'null'); }catch(e){}
      if(s&&s.b&&s.m){ g.querySelector('[data-mw-cn-gl]').textContent='Garajım · uyumlu parçalar'; g.querySelector('[data-mw-cn-gn]').textContent=s.b+' '+s.m; g.classList.add('has-moto'); }
    }
  }
  function open(from){
    last=from||null; load();
    cn.hidden=false; document.documentElement.classList.add('mw-cn-lock');
    requestAnimationFrame(function(){ cn.classList.add('is-open'); });
    var t=document.querySelector('[data-mw-tb-menu]'); if(t) t.setAttribute('aria-expanded','true');
    cn.focus({preventScroll:true});
  }
  function close(quiet){
    if(cn.hidden) return;
    cn.classList.remove('is-open'); document.documentElement.classList.remove('mw-cn-lock');
    setTimeout(function(){ if(!cn.classList.contains('is-open')) cn.hidden=true; },220);
    var t=document.querySelector('[data-mw-tb-menu]'); if(t) t.setAttribute('aria-expanded','false');
    if(quiet!==true&&last&&last.focus) last.focus({preventScroll:true});
  }
  cn.querySelector('[data-mw-cn-close]').addEventListener('click',function(){ close(); });
  cn.querySelector('[data-mw-cn-srch]').addEventListener('click',function(){
    close(true);
    var ss=document.querySelectorAll('details-modal.header__search summary');
    for(var i=0;ss.length>i;i++){ if(ss[i].offsetParent!==null){ viaHeader(ss[i]); return; } }
    window.location.href=root+'/search';
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!cn.hidden) close(); });
  var mq=window.matchMedia&&window.matchMedia('(max-width: 749px)'); if(mq&&mq.addEventListener) mq.addEventListener('change',function(e){ if(!e.matches) close(true); });
  window.mwCat={open:open,close:close,toggle:function(from){ if(cn.hidden) open(from); else close(); },preload:load,isOpen:function(){ return !cn.hidden; }};
})();}catch(e){setTimeout(function(){throw e;});}
try{(function(){
  var tb=document.querySelector('[data-mw-tb]'); if(!tb) return;
  document.body.classList.add('mw-tb-on');
  var root=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/').replace(/\/$/,'');
  var mo=tb.querySelector('[data-mw-tb-moto]'), ml=tb.querySelector('[data-mw-tb-mlabel]');
  function get(){ try{ var s=JSON.parse(localStorage.getItem('mw_moto')||'null'); return s&&s.b&&s.m?s:null; }catch(e){ return null; } }
  function furl(){ return root+'/pages/garajim'; }
  var onG=/\/pages\/garajim\/?$/.test(window.location.pathname);
  function label(){
    var s=get();
    ml.textContent=s?s.m:'Garajım';
    mo.classList.toggle('has-moto',!!s);
    mo.setAttribute('aria-label',s?'Garajım: '+s.b+' '+s.m:'Garajım');
    var on=false;
    if(s){ try{ on=new URL(window.location.href).searchParams.getAll('filter.p.m.custom.uyumlu_model').indexOf(s.m)>-1; }catch(e){} }
    if(onG) on=true;
    mo.classList.toggle('is-on',on);
    if(on){ var mi=tb.querySelector('[data-mw-tb-menu]'); if(mi) mi.classList.remove('is-on'); }
  }
  label();

  /* Kategoriler: kategori ekranını aç/kapat (motowing-catnav); yoksa temanın mobil menüsü (başlık kaydırmayla gizlendiyse önce göster) */
  var mn=tb.querySelector('[data-mw-tb-menu]');
  mn.addEventListener('touchstart',function(){ if(window.mwCat) window.mwCat.preload(); },{passive:true});
  /* Kategori ekranı açıkken alt çubuktaki başka bir sekmeye dokunulursa ekran kapansın */
  tb.addEventListener('click',function(e){ if(window.mwCat&&window.mwCat.isOpen()&&!e.target.closest('[data-mw-tb-menu]')) window.mwCat.close(true); },true);
  mn.addEventListener('click',function(e){
    if(window.mwCat){ e.preventDefault(); e.stopPropagation(); window.mwCat.toggle(mn); return; }
    var sm=document.querySelector('#Details-menu-drawer-container > summary'); if(!sm||sm.offsetParent===null) return;
    e.preventDefault(); e.stopPropagation();
    var hd=document.querySelector('.section-header'), sh=document.querySelector('sticky-header');
    if(hd&&sh&&typeof sh.reveal==='function'&&(hd.classList.contains('shopify-section-header-hidden')||hd.getBoundingClientRect().bottom<=0)){ sh.reveal(); setTimeout(function(){ sm.click(); },220); }
    else sm.click();
  });

  /* Sepetim: sepet çekmecesini aç; sayaç başlıktaki sepet ikonundan kopyalanır */
  var ct=tb.querySelector('[data-mw-tb-cart]'), cn=tb.querySelector('[data-mw-tb-cnt]');
  ct.addEventListener('click',function(e){ if(ct.hasAttribute('data-mw-tb-oncart')) return; var d=document.querySelector('cart-drawer'); if(d&&typeof d.open==='function'){ e.preventDefault(); e.stopPropagation(); d.open(ct); } });
  var bub=document.getElementById('cart-icon-bubble');
  function cnt(){
    var b=bub&&bub.querySelector('.cart-count-bubble'), sp=b&&b.querySelector('span[aria-hidden]'), n=0;
    if(b){ n=sp?parseInt(sp.textContent,10)||0:100; }
    cn.textContent=n>99?'99+':String(n); cn.hidden=n<1;
    if(n>0&&cn.getAttribute('data-n')!==String(n)&&cn.hasAttribute('data-n')){ cn.classList.remove('is-pop'); void cn.offsetWidth; cn.classList.add('is-pop'); }
    cn.setAttribute('data-n',String(n));
  }
  if(bub&&window.MutationObserver){ cnt(); new MutationObserver(cnt).observe(bub,{childList:true,subtree:true,characterData:true}); }

  /* Garajım paneli */
  var gs=document.querySelector('[data-mw-gs]'); if(!gs) return;
  var sheet=gs.querySelector('.mw-gs__sheet'), sv=gs.querySelector('[data-mw-gs-saved]'), fm=gs.querySelector('[data-mw-gs-form]');
  var sb=gs.querySelector('[data-mw-gs-b]'), sm2=gs.querySelector('[data-mw-gs-m]'), sub=gs.querySelector('[data-mw-gs-sub]');
  var d=[]; try{ d=JSON.parse(document.querySelector('[data-mw-tb-data]').textContent)||[]; }catch(e){}
  function opt(sel,v,t){ var o=document.createElement('option'); o.value=v; o.textContent=t; sel.appendChild(o); }
  d.forEach(function(x,i){ opt(sb,String(i),x[0]); });
  function models(){
    var x=d[sb.value]; sm2.length=0; opt(sm2,'','Model seç');
    if(!x){ sm2.disabled=true; sub.disabled=true; return; }
    x[2].forEach(function(n){ opt(sm2,n,n); });
    sm2.disabled=false; sub.disabled=!sm2.value;
  }
  sb.addEventListener('change',models);
  sm2.addEventListener('change',function(){ sub.disabled=!sm2.value; });
  function view(edit){
    var s=get();
    if(s&&!edit){
      gs.querySelector('[data-mw-gs-name]').textContent=s.b+' '+s.m;
      gs.querySelector('[data-mw-gs-go]').href=furl(s);
      sv.hidden=false; fm.hidden=true;
    } else {
      sv.hidden=true; fm.hidden=false;
      if(s){ for(var i=0;i<d.length;i++){ if(d[i][0]===s.b){ sb.value=String(i); models(); if(d[i][2].indexOf(s.m)>-1){ sm2.value=s.m; sub.disabled=false; } break; } } }
    }
  }
  var last=null;
  function open(){
    view(false); last=document.activeElement;
    gs.hidden=false; document.documentElement.classList.add('mw-gs-lock');
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ gs.classList.add('is-open'); sheet.focus({preventScroll:true}); }); });
  }
  function close(){
    gs.classList.remove('is-open'); document.documentElement.classList.remove('mw-gs-lock');
    setTimeout(function(){ gs.hidden=true; },280);
    if(last&&last.focus) last.focus({preventScroll:true});
  }
  mo.addEventListener('click',function(e){
    e.preventDefault(); e.stopPropagation();
    var g=onG&&document.querySelector('[data-mw-gr]');
    if(g){ try{ g.scrollIntoView({behavior:'smooth',block:'start'}); }catch(err){ window.scrollTo(0,0); } return; }
    open();
  });
  /* Sayfadaki "Motorunu seç" (#mw-motor) linkleri ana sayfaya gitmek yerine paneli açsın (çubuk görünürken) */
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href$="#mw-motor"]'); if(!a||!tb.getClientRects().length) return;
    if(document.getElementById('mw-motor')) return;
    e.preventDefault(); open();
  });
  /* Paneli aşağı kaydırarak kapat */
  var y0=null, dy=0;
  sheet.addEventListener('touchstart',function(e){ y0=sheet.scrollTop<=0?e.touches[0].clientY:null; dy=0; },{passive:true});
  sheet.addEventListener('touchmove',function(e){ if(y0===null) return; dy=Math.max(0,e.touches[0].clientY-y0); if(dy>0){ sheet.style.transition='none'; sheet.style.transform='translateY('+dy+'px)'; } },{passive:true});
  sheet.addEventListener('touchend',function(){ if(y0===null) return; sheet.style.transition=''; sheet.style.transform=''; if(dy>90) close(); y0=null; dy=0; });
  gs.addEventListener('click',function(e){ if(e.target.closest('[data-mw-gs-close]')) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!gs.hidden) close(); });
  gs.querySelector('[data-mw-gs-change]').addEventListener('click',function(){ view(true); });
  gs.querySelector('[data-mw-gs-del]').addEventListener('click',function(){
    try{ localStorage.removeItem('mw_moto'); }catch(e){}
    label(); sb.value=''; models(); view(false);
  });
  fm.addEventListener('submit',function(e){
    e.preventDefault(); var x=d[sb.value]; if(!x||!sm2.value) return;
    var s={b:x[0],m:sm2.value};
    try{ localStorage.setItem('mw_moto',JSON.stringify(s)); }catch(err){}
    window.location.href=furl(s);
  });
})();}catch(e){setTimeout(function(){throw e;});}
try{(function(){
  var b=document.querySelector('[data-mw-totop]'); if(!b) return;
  var on=false, tk=false;
  function u(){ tk=false; var s=window.scrollY>window.innerHeight*1.5; if(s!==on){ on=s; b.classList.toggle('is-on',s); } }
  window.addEventListener('scroll',function(){ if(!tk){ tk=true; requestAnimationFrame(u); } },{passive:true});
  b.addEventListener('click',function(){ var r=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches; window.scrollTo({top:0,behavior:r?'auto':'smooth'}); });
  u();
})();}catch(e){setTimeout(function(){throw e;});}
try{(function(){
  if(window.mwQa) return; window.mwQa=true;
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-mw-qa]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    if(b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/', d=document.querySelector('cart-drawer');
    var body={items:[{id:+b.getAttribute('data-mw-qa'),quantity:1}]};
    if(d&&d.renderContents){ body.sections='cart-drawer,cart-icon-bubble'; body.sections_url=window.location.pathname; }
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){ return r.json(); })
      .then(function(j){
        b.classList.remove('is-busy');
        if(j.status){ window.location.href=b.getAttribute('data-url'); return; }
        b.classList.add('is-done'); setTimeout(function(){ b.classList.remove('is-done'); },1600);
        if(d&&d.renderContents&&j.sections){ d.classList.remove('is-empty'); if(b.closest('cart-drawer')||!quiet(d,j)){ d.renderContents(j); } else { fly(b); toast(b); } } else { window.location.href=root+'cart'; return; }
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'mw-quick-add',cartData:j});
      })
      .catch(function(){ b.classList.remove('is-busy'); window.location.href=b.getAttribute('data-url'); });
  });
  /* Sepet çekmecesini açmadan yenile (Trendyol tarzı: liste/kart üzerinden eklerken sayfada kal) */
  function quiet(d,j){
    try{
      d.getSectionsToRender().forEach(function(x){
        var t=x.selector?document.querySelector(x.selector):document.getElementById(x.id);
        if(t&&j.sections[x.id]) t.innerHTML=d.getSectionInnerHTML(j.sections[x.id],x.selector);
      });
      var ov=d.querySelector('#CartDrawer-Overlay'); if(ov&&!ov.mwOv){ ov.mwOv=1; ov.addEventListener('click',d.close.bind(d)); }
      var di=d.querySelector('.drawer__inner'); if(di) di.classList.remove('is-empty');
      return true;
    }catch(err){ return false; }
  }
  var RM=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function vis(x){ if(!x||!x.getClientRects().length) return null; var r=x.getBoundingClientRect(); return r.width>0&&r.bottom>0&&window.innerHeight>r.top?r:null; }
  function pic(b){ var w=b.closest('.product-card-wrapper,.mw-gr__card,.mw-fv__it,li'); if(!w) return null; var ims=w.querySelectorAll('img'); for(var i=0;ims.length>i;i++){ var r=vis(ims[i]); if(r&&r.width>36) return ims[i]; } return null; }
  /* Ürün görseli sepete uçar (alt menüdeki Sepetim ya da başlıktaki sepet ikonu) */
  function fly(b){
    if(RM||!document.body.animate||!b.closest('.product-card-wrapper,.mw-gr__card')) return;
    var src=pic(b); if(!src) return;
    var t=document.querySelector('[data-mw-tb-cart] .mw-tb__ic'), z=vis(t); if(!z){ t=document.getElementById('cart-icon-bubble'); z=vis(t); } if(!z) return;
    var a=src.getBoundingClientRect(), s=Math.min(a.width,a.height,160), x0=a.left+a.width/2-s/2, y0=a.top+a.height/2-s/2;
    var f=new Image(); f.src=src.currentSrc||src.src; f.alt=''; f.className='mw-fly';
    f.style.cssText='left:'+x0+'px;top:'+y0+'px;width:'+s+'px;height:'+s+'px';
    document.body.appendChild(f);
    var dx=z.left+z.width/2-(x0+s/2), dy=z.top+z.height/2-(y0+s/2), my=Math.min(dy,0)*.5-90;
    var an=f.animate([{transform:'translate3d(0,0,0) scale(1)',opacity:1},{transform:'translate3d('+(dx*.45)+'px,'+my+'px,0) scale(.5)',opacity:1,offset:.45},{transform:'translate3d('+dx+'px,'+dy+'px,0) scale(.08)',opacity:.5}],{duration:720,easing:'cubic-bezier(.45,0,.2,1)'});
    an.onfinish=function(){ f.remove(); t.classList.remove('mw-bump'); void t.offsetWidth; t.classList.add('mw-bump'); };
  }
  /* "Sepete eklendi" bildirimi: görsel, ad, ücretsiz kargoya kalan tutar, Sepete git */
  var T=null, tm=0;
  function hide(){ if(!T||T.hidden) return; clearTimeout(tm); T.classList.remove('is-on'); setTimeout(function(){ if(!T.classList.contains('is-on')) T.hidden=true; },RM?0:280); }
  function arm(){ clearTimeout(tm); tm=setTimeout(hide,5200); }
  function tl(c){ c=Math.round(c); var f=c%100, s=String(Math.floor(c/100)).replace(/\B(?=(\d{3})+(?!\d))/g,'.'); return s+(f?','+('0'+f).slice(-2):'')+'₺'; }
  function toast(b,vt){
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    if(!T){
      T=document.createElement('div'); T.className='mw-toast'; T.hidden=true; T.setAttribute('role','status'); T.setAttribute('aria-live','polite');
      T.innerHTML='<span class="mw-toast__img"></span><span class="mw-toast__b"><span class="mw-toast__h"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>Sepete eklendi</span><span class="mw-toast__n"></span><span class="mw-toast__fs" hidden><span class="mw-toast__ft"></span><span class="mw-toast__bar"><i></i></span></span></span><button type="button" class="mw-toast__go">Sepete git</button><button type="button" class="mw-toast__x" aria-label="Bildirimi kapat"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
      document.body.appendChild(T);
      T.querySelector('.mw-toast__go').addEventListener('click',function(){ hide(); var d=document.querySelector('cart-drawer'); if(d&&typeof d.open==='function') d.open(); else window.location.href=root+'cart'; });
      T.querySelector('.mw-toast__x').addEventListener('click',hide);
      T.addEventListener('mouseenter',function(){ clearTimeout(tm); });
      T.addEventListener('mouseleave',arm);
      var y0=null; T.addEventListener('touchstart',function(e){ y0=e.touches[0].clientY; },{passive:true});
      T.addEventListener('touchend',function(e){ if(y0!==null&&e.changedTouches[0].clientY-y0>30) hide(); y0=null; });
    }
    var im=pic(b), ib=T.querySelector('.mw-toast__img'); ib.innerHTML='';
    if(im){ var c=new Image(); c.src=im.currentSrc||im.src; c.alt=''; ib.appendChild(c); ib.hidden=false; } else ib.hidden=true;
    T.querySelector('.mw-toast__n').textContent=(b.getAttribute('aria-label')||'').replace(/^(Sepete ekle|Seçenek seç):\s*/,'')+(vt?' · '+vt:'');
    var fs=T.querySelector('.mw-toast__fs'); fs.hidden=true;
    if(window.innerWidth>749){ var hd=document.querySelector('.section-header'), r=hd&&hd.getBoundingClientRect(); T.style.top=Math.max(16,(r&&r.bottom>0?r.bottom:0)+12)+'px'; } else T.style.top='';
    T.classList.remove('is-on'); T.hidden=false; void T.offsetWidth; T.classList.add('is-on'); arm();
    fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(c){
      var t=c.total_price, g=700000, ft=T.querySelector('.mw-toast__ft'), bi=T.querySelector('.mw-toast__bar i'), bar=T.querySelector('.mw-toast__bar');
      if(!(t>0)) return;
      if(t>=g){ ft.innerHTML='<b class="is-g">Kargo ücretsiz</b> · Sepetin 7.000₺\'yi geçti'; bar.hidden=true; }
      else { ft.innerHTML='Ücretsiz kargoya <b>'+tl(g-t)+'</b> kaldı'; bar.hidden=false; bi.style.width='0'; requestAnimationFrame(function(){ requestAnimationFrame(function(){ bi.style.width=Math.max(4,Math.round(t*100/g))+'%'; }); }); }
      fs.hidden=false;
    }).catch(function(){});
  }
  /* Seçenekli ürünler (renk/beden): karttaki sepet butonu seçim panelini açar; bilgisayarda (fare, 990px+) Hızlı Bak açılır */
  var VS=null, vsB=null, vsP=null, vsSel=[], vsTok=0, vsCache={};
  var X='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  function vsRoot(){ return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/'; }
  function vsGet(h){ if(!vsCache[h]) vsCache[h]=fetch(vsRoot()+'products/'+encodeURIComponent(h)+'.js',{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).catch(function(e){ delete vsCache[h]; throw e; }); return vsCache[h]; }
  function vsOpt(v,i){ return v.options?v.options[i]:v['option'+(i+1)]; }
  function vsUniq(a){ var r=[]; a.forEach(function(x){ if(x!=null&&r.indexOf(x)===-1) r.push(x); }); return r; }
  function vsSrc(u,w){ u=String(u||''); if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; return u+(u.indexOf('?')>-1?'&':'?')+'width='+w; }
  function vsImg(u){ var ib=VS.querySelector('.mw-vs__img'); ib.innerHTML=''; if(!u) return; var c=new Image(); c.src=u; c.alt=''; ib.appendChild(c); }
  function vsBuild(){
    VS=document.createElement('div'); VS.className='mw-vs'; VS.hidden=true;
    VS.innerHTML='<span class="mw-vs__ov" data-mw-vs-x></span><div class="mw-vs__box" role="dialog" aria-modal="true" aria-labelledby="mw-vs-t" tabindex="-1"><span class="mw-vs__grab" aria-hidden="true"></span><div class="mw-vs__hd"><span class="mw-vs__img"></span><span class="mw-vs__hi"><span class="mw-vs__t" id="mw-vs-t"></span><span class="mw-vs__pr"><b class="mw-vs__p"></b><s class="mw-vs__c"></s></span></span><button type="button" class="mw-vs__x" data-mw-vs-x aria-label="Kapat">'+X+'</button></div><div class="mw-vs__body"></div><p class="mw-vs__msg" role="alert" hidden></p><button type="button" class="mw-vs__add" disabled>Sepete Ekle</button></div>';
    document.body.appendChild(VS);
    VS.addEventListener('click',function(e){ if(e.target.closest('[data-mw-vs-x]')) vsClose(); });
    document.addEventListener('keydown',function(e){ if(VS&&!VS.hidden&&e.key==='Escape') vsClose(); });
    VS.querySelector('.mw-vs__add').addEventListener('click',vsAdd);
    var box=VS.querySelector('.mw-vs__box'), y0=null;
    box.addEventListener('touchstart',function(e){ y0=box.scrollTop>0?null:e.touches[0].clientY; },{passive:true});
    box.addEventListener('touchend',function(e){ if(y0!==null&&e.changedTouches[0].clientY-y0>80) vsClose(); y0=null; });
  }
  function vsClose(){
    if(!VS||VS.hidden) return; vsTok++;
    VS.classList.remove('is-open'); document.documentElement.classList.remove('mw-vs-lock');
    setTimeout(function(){ if(!VS.classList.contains('is-open')) VS.hidden=true; },RM?0:260);
    if(vsB&&vsB.focus) vsB.focus({preventScroll:true});
  }
  function vsOpen(b){
    if(!VS) vsBuild();
    var tok=++vsTok, im=pic(b), add=VS.querySelector('.mw-vs__add');
    vsB=b; vsP=null;
    VS.querySelector('.mw-vs__t').textContent=(b.getAttribute('aria-label')||'').replace(/^Seçenek seç:\s*/,'');
    VS.querySelector('.mw-vs__p').textContent=''; VS.querySelector('.mw-vs__c').textContent='';
    vsImg(im?(im.currentSrc||im.src):'');
    VS.querySelector('.mw-vs__body').innerHTML='<span class="mw-vs__ld">Seçenekler yükleniyor…</span>';
    add.disabled=true; add.textContent='Sepete Ekle'; VS.querySelector('.mw-vs__msg').hidden=true;
    VS.hidden=false; document.documentElement.classList.add('mw-vs-lock'); void VS.offsetWidth; VS.classList.add('is-open');
    VS.querySelector('.mw-vs__box').focus({preventScroll:true});
    vsGet(b.getAttribute('data-mw-qo')).then(function(p){ if(tok!==vsTok) return; vsP=p; vsRender(); }).catch(function(){ if(tok===vsTok) window.location.href=b.getAttribute('data-url'); });
  }
  function vsRender(){
    var V=vsP.variants||[], O=(vsP.options||[]).map(function(o,i){ return typeof o==='string'?{name:o,values:vsUniq(V.map(function(v){ return vsOpt(v,i); }))}:o; });
    var f=V.filter(function(v){ return v.available; })[0]||V[0], body=VS.querySelector('.mw-vs__body');
    vsSel=O.map(function(o,i){ return f?vsOpt(f,i):(o.values||[])[0]; });
    body.innerHTML='';
    O.forEach(function(o,i){
      var g=document.createElement('div'), l=document.createElement('p'), cur=document.createElement('b'), cs=document.createElement('div');
      g.className='mw-vs__g'; l.className='mw-vs__l'; l.textContent=o.name+': '; l.appendChild(cur); g.appendChild(l);
      cs.className='mw-vs__cs'; cs.setAttribute('role','radiogroup'); cs.setAttribute('aria-label',o.name);
      (o.values||[]).forEach(function(val){ var c=document.createElement('button'); c.type='button'; c.className='mw-vs__ch'; c.textContent=val; c.setAttribute('role','radio'); c._i=i; c._v=val; c.addEventListener('click',function(){ vsSel[i]=val; vsUpd(); }); cs.appendChild(c); });
      g.appendChild(cs); body.appendChild(g);
    });
    vsUpd();
  }
  function vsFind(sel){ var V=vsP.variants||[]; for(var i=0;V.length>i;i++){ var ok=true; for(var k=0;sel.length>k;k++){ if(vsOpt(V[i],k)!==sel[k]){ ok=false; break; } } if(ok) return V[i]; } return null; }
  function vsUpd(){
    var v=vsFind(vsSel), add=VS.querySelector('.mw-vs__add');
    [].forEach.call(VS.querySelectorAll('.mw-vs__ch'),function(c){ var on=vsSel[c._i]===c._v, s=vsSel.slice(); s[c._i]=c._v; var x=vsFind(s); c.classList.toggle('is-on',on); c.setAttribute('aria-checked',on?'true':'false'); c.classList.toggle('is-na',!(x&&x.available)); });
    [].forEach.call(VS.querySelectorAll('.mw-vs__l b'),function(b,i){ b.textContent=vsSel[i]||''; });
    var pr=v?v.price:vsP.price, cp=v?v.compare_at_price:0;
    VS.querySelector('.mw-vs__p').textContent=tl(pr); VS.querySelector('.mw-vs__c').textContent=cp&&cp>pr?tl(cp):'';
    if(v&&v.featured_image&&v.featured_image.src) vsImg(vsSrc(v.featured_image.src,160));
    add.disabled=!(v&&v.available); add.textContent=!v?'Bu seçenek yok':(v.available?'Sepete Ekle':'Tükendi');
    VS.querySelector('.mw-vs__msg').hidden=true;
  }
  function vsAdd(){
    var v=vsP&&vsFind(vsSel), add=VS.querySelector('.mw-vs__add'), msg=VS.querySelector('.mw-vs__msg'), b=vsB;
    if(!v||!v.available||add.classList.contains('is-busy')) return;
    add.classList.add('is-busy'); msg.hidden=true;
    var d=document.querySelector('cart-drawer'), body={items:[{id:v.id,quantity:1}]};
    if(d&&d.renderContents){ body.sections='cart-drawer,cart-icon-bubble'; body.sections_url=window.location.pathname; }
    fetch(vsRoot()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){ return r.json(); })
      .then(function(j){
        add.classList.remove('is-busy');
        if(j.status){ msg.textContent=j.description||j.message||'Sepete eklenemedi.'; msg.hidden=false; return; }
        var vt=v.title&&!/default/i.test(v.title)?v.title:'';
        vsClose();
        b.classList.add('is-done'); setTimeout(function(){ b.classList.remove('is-done'); },1600);
        if(d&&d.renderContents&&j.sections){ d.classList.remove('is-empty'); if(!quiet(d,j)){ d.renderContents(j); } else { fly(b); toast(b,vt); } } else { window.location.href=vsRoot()+'cart'; return; }
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'mw-quick-add',cartData:j});
      })
      .catch(function(){ add.classList.remove('is-busy'); msg.textContent='Bağlantı sorunu, tekrar dene.'; msg.hidden=false; });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-mw-qo]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var w=b.closest('.product-card-wrapper'), q=w&&w.querySelector('.mw-qvb');
    if(q&&window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:990px)').matches){ q.click(); return; }
    vsOpen(b);
  });
})();}catch(e){setTimeout(function(){throw e;});}
try{(function(){
  /* "Motoruna uyar": ziyaretçinin seçtiği motor (mw_moto) kartın uyumlu marka + model listesinde birebir varsa etiketi göster; filtreyle/sonradan eklenen kartlar için DOM izlenir */
  var s; try{ s=JSON.parse(localStorage.getItem('mw_moto')||'null'); }catch(e){ return; }
  if(!s||!s.b||!s.m) return;
  var B=String(s.b).toLowerCase(), M=String(s.m).toLowerCase(), q=false;
  function has(a,v){ if(!Array.isArray(a)) return false; for(var i=0;a.length>i;i++){ if(String(a[i]).toLowerCase()===v) return true; } return false; }
  function run(){
    q=false;
    var els=document.querySelectorAll('.mw-fitc[hidden]:not([data-mw-done])');
    for(var i=0;els.length>i;i++){
      var el=els[i], mk, md; el.setAttribute('data-mw-done','');
      try{ mk=JSON.parse(el.getAttribute('data-mk')); md=JSON.parse(el.getAttribute('data-md')); }catch(e){ continue; }
      if(has(mk,B)&&has(md,M)) el.hidden=false;
    }
  }
  run();
  if(window.MutationObserver) new MutationObserver(function(){ if(!q){ q=true; requestAnimationFrame(run); } }).observe(document.body,{childList:true,subtree:true});
})();}catch(e){setTimeout(function(){throw e;});}
try{(function(){
  if(window.mwQv) return; window.mwQv=true;
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/', FMT=window.mwFMT||'{{amount_with_comma_separator}} TL';
  var H=['01-01','04-23','05-01','05-19','07-15','08-30','10-29'];
  var TRM=['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'], TRD=['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
  var TR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M1 4h13v12H1zM14 8h4l4 4v4h-8"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>';
  /* Bir sonraki kargo günü (İstanbul saati) */
  function hol(x){ return H.indexOf(('0'+(x.getMonth()+1)).slice(-2)+'-'+('0'+x.getDate()).slice(-2))>-1; }
  function ship(){
    try{
      /* Türkiye 2016'dan beri sabit UTC+3 (yaz saati yok): İstanbul saati elle hesaplanır; Intl saat dilimi verisi yüklenmez (her sayfada gereksiz ~10-50 ms) */
      var t=new Date(Date.now()+108e5), g={year:t.getUTCFullYear(),month:t.getUTCMonth()+1,day:t.getUTCDate(),hour:t.getUTCHours(),minute:t.getUTCMinutes(),second:t.getUTCSeconds()};
      var d=new Date(+g.year,+g.month-1,+g.day);
      for(var i=1;15>i;i++){
        var n=new Date(d.getFullYear(),d.getMonth(),d.getDate()+i), w=n.getDay();
        if((w===1||w===3||w===5)&&!hol(n)) return {day:n,inDays:i,left:i*86400-((+g.hour%24)*3600+(+g.minute)*60+(+g.second))};
      }
    }catch(e){}
    return null;
  }
  function dayName(r){ return r.inDays===1?'Yarın':TRD[r.day.getDay()]; }
  function dur(s){ var h=Math.floor(s/3600), m=Math.floor(s%3600/60); return h?h+' sa '+m+' dk':Math.max(m,1)+' dk'; }
  /* Para biçimi (mağaza ayarı) */
  function num(c,d,t,s){ var p=(c/100).toFixed(d).split('.'); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,t); return p[1]?p[0]+s+p[1]:p[0]; }
  function money(c){
    var m=FMT.match(/\{\{\s*(\w+)\s*\}\}/); if(!m) return num(c,2,'.',',')+' TL';
    var v={amount:num(c,2,',','.'),amount_no_decimals:num(c,0,',','.'),amount_with_comma_separator:num(c,2,'.',','),amount_no_decimals_with_comma_separator:num(c,0,'.',','),amount_with_space_separator:num(c,2,' ',','),amount_with_period_and_space_separator:num(c,2,' ','.'),amount_with_apostrophe_separator:num(c,2,"'",'.')}[m[1]];
    return FMT.replace(m[0],v||num(c,2,',','.'));
  }
  function el(t,c,x){ var e=document.createElement(t); if(c) e.className=c; if(x!=null) e.textContent=x; return e; }
  function img(u,w){ if(!u) return ''; u=String(u); if(u.indexOf('//')===0) u='https:'+u; return u+(u.indexOf('?')>-1?'&':'?')+'width='+w; }
  function hOf(href){ var m=String(href||'').match(/\/products\/([^?#\/]+)/); return m?decodeURIComponent(m[1]):''; }
  var SHIP=ship();
  var HOVER=window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:990px)').matches;

  /* ---------- Kartlar: kargo rozeti + Hızlı Bak düğmesi ---------- */
  var queued=false;
  function scan(){
    queued=false;
    if(SHIP){
      var sc=document.querySelectorAll('.mw-shipc[hidden]:not([data-mw-done])'), lbl=dayName(SHIP)+' kargoda';
      for(var i=0;sc.length>i;i++){ sc[i].setAttribute('data-mw-done',''); sc[i].innerHTML=TR; sc[i].appendChild(document.createTextNode(lbl)); sc[i].hidden=false; }
    }
    if(!HOVER) return;
    var cs=document.querySelectorAll('.product-card-wrapper .card__inner:not([data-mw-qvd])');
    for(var j=0;cs.length>j;j++){
      var ci=cs[j]; ci.setAttribute('data-mw-qvd','');
      var w=ci.closest('.product-card-wrapper'), a=w&&w.querySelector('a[href*="/products/"]'), h=a?hOf(a.getAttribute('href')):'';
      if(!h) continue;
      var b=el('button','mw-qvb'); b.type='button'; b.setAttribute('data-mw-qvh',h);
      b.setAttribute('aria-label','Hızlı bak: '+(a.textContent||'').replace(/\s+/g,' ').trim());
      b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg><span>Hızlı Bak</span>';
      ci.appendChild(b);
    }
  }
  scan();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan);
  if(window.MutationObserver) new MutationObserver(function(){ if(!queued){ queued=true; requestAnimationFrame(scan); } }).observe(document.documentElement,{childList:true,subtree:true});
  if(!HOVER) return;

  /* ---------- Hızlı Bak penceresi ---------- */
  var cache={}, M=null, last=null, cur=null;
  function get(h){
    if(!cache[h]) cache[h]=fetch(ROOT+'products/'+encodeURIComponent(h)+'.js',{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).catch(function(e){ delete cache[h]; throw e; });
    return cache[h];
  }
  document.addEventListener('mouseover',function(e){ var b=e.target.closest&&e.target.closest('[data-mw-qvh]'); if(b) get(b.getAttribute('data-mw-qvh')).catch(function(){}); });
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-mw-qvh]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var w=b.closest('.product-card-wrapper'), cm=w&&w.querySelector('.mw-cm'), meta={ith:false,alt:false,mk:[],md:[]};
    if(cm){ meta.ith=cm.hasAttribute('data-ith'); meta.alt=cm.hasAttribute('data-alt'); try{ meta.mk=JSON.parse(cm.getAttribute('data-mk')||'[]')||[]; meta.md=JSON.parse(cm.getAttribute('data-md')||'[]')||[]; }catch(err){} }
    open(b.getAttribute('data-mw-qvh'),meta,b);
  },true);

  function build(){
    M=el('div','mw-qv'); M.hidden=true;
    M.innerHTML='<div class="mw-qv__ov" data-mw-qv-x></div><div class="mw-qv__box" role="dialog" aria-modal="true" aria-labelledby="mw-qv-t" tabindex="-1"><button type="button" class="mw-qv__x" data-mw-qv-x aria-label="Kapat"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="mw-qv__body" data-mw-qv-body></div></div>';
    document.body.appendChild(M);
    M.addEventListener('click',function(e){ if(e.target.closest('[data-mw-qv-x]')) close(); });
    document.addEventListener('keydown',function(e){
      if(!M||M.hidden) return;
      if(e.key==='Escape'){ e.preventDefault(); close(); return; }
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){ var t=e.target; if(t&&(t.tagName==='SELECT'||t.tagName==='INPUT')) return; var g=M.querySelector(e.key==='ArrowRight'?'[data-mw-qv-nx]':'[data-mw-qv-pv]'); if(g) g.click(); }
      if(e.key==='Tab'){
        var f=[].slice.call(M.querySelectorAll('a[href],button:not([disabled]),select,input')).filter(function(x){ return x.getClientRects().length; });
        if(!f.length) return; var a=f[0], z=f[f.length-1];
        if(e.shiftKey&&document.activeElement===a){ e.preventDefault(); z.focus(); } else if(!e.shiftKey&&document.activeElement===z){ e.preventDefault(); a.focus(); }
      }
    });
  }
  function close(){
    if(!M||M.hidden) return;
    M.classList.remove('is-open'); document.documentElement.classList.remove('mw-qv-lock');
    setTimeout(function(){ if(!M.classList.contains('is-open')) M.hidden=true; },220);
    if(last&&last.focus) last.focus({preventScroll:true});
    cur=null;
  }
  function open(h,meta,from){
    if(!M) build();
    last=from; cur=h;
    var body=M.querySelector('[data-mw-qv-body]');
    body.innerHTML='<div class="mw-qv__ld"><span class="mw-qv__sp"></span>Yükleniyor…</div>';
    M.hidden=false; document.documentElement.classList.add('mw-qv-lock');
    requestAnimationFrame(function(){ M.classList.add('is-open'); M.querySelector('.mw-qv__box').focus({preventScroll:true}); });
    get(h).then(function(p){ if(cur!==h) return; render(p,meta); })
      .catch(function(){ if(cur!==h) return; body.innerHTML=''; var e=el('div','mw-qv__ld','Ürün yüklenemedi. '); var a=el('a','','Ürün sayfasına git'); a.href=ROOT+'products/'+encodeURIComponent(h); e.appendChild(a); body.appendChild(e); });
  }

  function specs(html){
    var out={intro:'',rows:[]};
    try{
      var d=new DOMParser().parseFromString('<div>'+String(html||'')+'</div>','text/html');
      var p=d.querySelector('p'); if(p) out.intro=p.textContent.replace(/\s+/g,' ').trim();
      var ul=d.querySelector('ul');
      if(ul){ [].slice.call(ul.querySelectorAll('li')).slice(0,6).forEach(function(li){ var t=li.textContent.replace(/\s+/g,' ').trim(), k=t.indexOf(':'); if(t) out.rows.push(k>0&&40>k?[t.slice(0,k).trim(),t.slice(k+1).trim()]:['',t]); }); }
    }catch(e){}
    if(out.intro.length>240) out.intro=out.intro.slice(0,237).replace(/\s+\S*$/,'')+'…';
    return out;
  }

  function render(p,meta){
    var body=M.querySelector('[data-mw-qv-body]'); body.innerHTML='';
    var url=p.url||(ROOT+'products/'+p.handle);
    /* Galeri */
    var imgs=(p.media&&p.media.length?p.media.filter(function(m){ return m.media_type==='image'||m.preview_image; }).map(function(m){ return m.src||(m.preview_image&&m.preview_image.src); }):p.images||[]).filter(Boolean).slice(0,8);
    var gal=el('div','mw-qv__gal'), main=el('div','mw-qv__main'), im=new Image(), idx=0;
    im.alt=p.title; im.width=640; im.height=640; im.decoding='async'; main.appendChild(im);
    function show(i){ if(!imgs.length) return; idx=(i+imgs.length)%imgs.length; im.src=img(imgs[idx],900); [].forEach.call(th.children,function(c,k){ c.classList.toggle('is-on',k===idx); c.setAttribute('aria-current',k===idx?'true':'false'); }); }
    gal.appendChild(main);
    var th=el('div','mw-qv__th');
    if(imgs.length>1){
      var pv=el('button','mw-qv__nav mw-qv__nav--p'), nx=el('button','mw-qv__nav mw-qv__nav--n');
      pv.type=nx.type='button'; pv.setAttribute('data-mw-qv-pv',''); nx.setAttribute('data-mw-qv-nx','');
      pv.setAttribute('aria-label','Önceki görsel'); nx.setAttribute('aria-label','Sonraki görsel');
      pv.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 6l-6 6 6 6"/></svg>';
      nx.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg>';
      pv.addEventListener('click',function(){ show(idx-1); }); nx.addEventListener('click',function(){ show(idx+1); });
      main.appendChild(pv); main.appendChild(nx);
      imgs.forEach(function(u,k){ var t=el('button','mw-qv__t'); t.type='button'; t.setAttribute('aria-label','Görsel '+(k+1)); var ti=new Image(); ti.src=img(u,160); ti.alt=''; ti.width=72; ti.height=72; ti.loading='lazy'; t.appendChild(ti); t.addEventListener('click',function(){ show(k); }); th.appendChild(t); });
      gal.appendChild(th);
    }
    show(0);
    body.appendChild(gal);

    /* Bilgi */
    var inf=el('div','mw-qv__inf');
    var s=specs(p.description);
    var tags=el('div','mw-qv__tags');
    var mk=meta.mk||[], md=meta.md||[], uni=mk.indexOf('Universal')>-1;
    var gar=null; try{ gar=JSON.parse(localStorage.getItem('mw_moto')||'null'); }catch(e){}
    var fitOk=!uni&&gar&&gar.b&&gar.m&&mk.indexOf(gar.b)>-1&&md.indexOf(gar.m)>-1;
    if(fitOk){ var fo=el('span','mw-qv__tag is-ok'); fo.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>'; fo.appendChild(document.createTextNode(gar.b+' '+gar.m+' motoruna uyar')); tags.appendChild(fo); }
    if(meta.ith) tags.appendChild(el('span','mw-qv__tag','İthal ürün'));
    if(tags.children.length) inf.appendChild(tags);
    var h2=el('h2','mw-qv__ttl',p.title); h2.id='mw-qv-t'; inf.appendChild(h2);

    var pr=el('div','mw-qv__pr'), pv0=el('span','mw-qv__pnow'), pc=el('s','mw-qv__pold'), pd=el('span','mw-qv__pdis');
    pr.appendChild(pv0); pr.appendChild(pc); pr.appendChild(pd); inf.appendChild(pr);
    var fs=el('p','mw-qv__fs'); fs.innerHTML=TR; fs.appendChild(document.createTextNode('Ücretsiz Kargo')); fs.hidden=true; inf.appendChild(fs);

    if(mk.length&&!uni){
      var fb=el('div','mw-qv__fit'); fb.appendChild(el('span','mw-qv__fl','Uyumlu motorlar'));
      var ch=el('div','mw-qv__chips'), list=[];
      if(mk.length===1&&md.length){ md.forEach(function(m){ list.push(mk[0]+' '+m); }); } else { list=mk.concat(md); }
      list.slice(0,6).forEach(function(t){ ch.appendChild(el('span','mw-qv__chip',t)); });
      if(list.length>6) ch.appendChild(el('span','mw-qv__chip is-more','+'+(list.length-6)));
      fb.appendChild(ch); inf.appendChild(fb);
    } else if(uni){ var fu=el('div','mw-qv__fit'); fu.appendChild(el('span','mw-qv__fl','Uyumlu motorlar')); var cu=el('div','mw-qv__chips'); cu.appendChild(el('span','mw-qv__chip','Universal ürün')); fu.appendChild(cu); inf.appendChild(fu); }

    if(s.rows.length){
      var dl=el('dl','mw-qv__spec');
      s.rows.forEach(function(r){ if(/^Uyumlu/i.test(r[0])&&mk.length) return; var dt=el('dt','',r[0]||'•'), dd=el('dd','',r[1]); dl.appendChild(dt); dl.appendChild(dd); });
      if(dl.children.length) inf.appendChild(dl);
    } else if(s.intro){ inf.appendChild(el('p','mw-qv__intro',s.intro)); }

    /* Seçenekler */
    var V=p.variants||[], opts=(p.options||[]).map(function(o,i){ return typeof o==='string'?{name:o,values:uniq(V.map(function(v){ return v.options?v.options[i]:v['option'+(i+1)]; }))}:o; });
    function uniq(a){ var r=[]; a.forEach(function(x){ if(x!=null&&r.indexOf(x)===-1) r.push(x); }); return r; }
    var single=V.length===1&&(!opts.length||(opts.length===1&&opts[0].values&&opts[0].values.length===1&&/default/i.test(opts[0].values[0])));
    var sels=[];
    if(!single&&opts.length){
      var vw=el('div','mw-qv__opts');
      opts.forEach(function(o,i){
        var lab=el('label','mw-qv__ol'), sp=el('span','',o.name), wr=el('span','mw-qv__sel'), sel=document.createElement('select');
        (o.values||[]).forEach(function(v){ var op=document.createElement('option'); op.value=v; op.textContent=v; sel.appendChild(op); });
        sel.addEventListener('change',upd); sels.push(sel); wr.appendChild(sel); lab.appendChild(sp); lab.appendChild(wr); vw.appendChild(lab);
      });
      inf.appendChild(vw);
    }
    var first=V.filter(function(v){ return v.available; })[0]||V[0];
    if(first&&sels.length){ sels.forEach(function(sel,i){ var val=first.options?first.options[i]:first['option'+(i+1)]; if(val!=null) sel.value=val; }); }

    /* Kargo satırı */
    var sl=el('p','mw-qv__ship'); inf.appendChild(sl);

    /* Sepet */
    var buy=el('div','mw-qv__buy'), qty=el('div','mw-qv__qty'), mi=el('button','',''), qi=document.createElement('input'), pl=el('button','','');
    mi.type=pl.type='button'; mi.setAttribute('aria-label','Azalt'); pl.setAttribute('aria-label','Artır'); mi.textContent='−'; pl.textContent='+';
    qi.type='number'; qi.min='1'; qi.max='99'; qi.value='1'; qi.setAttribute('aria-label','Adet'); qi.inputMode='numeric';
    mi.addEventListener('click',function(){ qi.value=Math.max(1,(+qi.value||1)-1); }); pl.addEventListener('click',function(){ qi.value=Math.min(99,(+qi.value||1)+1); });
    qty.appendChild(mi); qty.appendChild(qi); qty.appendChild(pl);
    var add=el('button','mw-qv__add','Sepete Ekle'); add.type='button';
    var msg=el('p','mw-qv__msg'); msg.setAttribute('role','alert'); msg.hidden=true;
    if(meta.alt){ var go=el('a','mw-qv__add','Ürünü İncele'); go.href=url; buy.appendChild(go); }
    else { buy.appendChild(qty); buy.appendChild(add); }
    inf.appendChild(buy); inf.appendChild(msg);
    var more=el('a','mw-qv__more','Ürün detaylarına git'); more.href=url;
    more.insertAdjacentHTML('beforeend','<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>');
    inf.appendChild(more);
    body.appendChild(inf);

    var vcur=null;
    function pick(){
      if(!sels.length) return first;
      var vals=sels.map(function(s){ return s.value; });
      for(var i=0;V.length>i;i++){ var v=V[i], ok=true; for(var k=0;vals.length>k;k++){ var ov=v.options?v.options[k]:v['option'+(k+1)]; if(ov!==vals[k]){ ok=false; break; } } if(ok) return v; }
      return null;
    }
    function upd(){
      vcur=pick(); msg.hidden=true;
      var price=vcur?vcur.price:p.price, cmp=vcur?vcur.compare_at_price:p.compare_at_price;
      pv0.textContent=money(price);
      if(cmp&&cmp>price){ pc.textContent=money(cmp); pc.hidden=false; pd.textContent='%'+Math.round((cmp-price)*100/cmp)+' indirim'; pd.hidden=false; } else { pc.hidden=true; pd.hidden=true; }
      fs.hidden=!(vcur&&vcur.available&&price>=700000&&!meta.ith&&!meta.alt);
      var av=!!(vcur&&vcur.available);
      if(!meta.alt){ add.disabled=!av; add.textContent=vcur?(av?'Sepete Ekle':'Tükendi'):'Bu seçenek yok'; qty.hidden=!av; }
      if(vcur&&vcur.featured_image&&vcur.featured_image.src){ var k=imgs.indexOf(vcur.featured_image.src); if(k>-1) show(k); }
      /* Kargo satırı */
      sl.innerHTML=''; sl.className='mw-qv__ship';
      if(meta.alt){ sl.hidden=true; }
      else if(meta.ith){ sl.textContent='İthal ürün: 10.500₺ kargo ücreti ayrıca uygulanır.'; sl.classList.add('is-ith'); sl.hidden=false; }
      else if(av&&SHIP){
        var r=ship()||SHIP, dn=dayName(r), dd=r.day.getDate()+' '+TRM[r.day.getMonth()];
        sl.innerHTML=TR+(86400>r.left?'<span><b class="is-r">'+dur(r.left)+'</b> içinde sipariş ver, <b>'+dn+'</b> kargoda</span>':'<span><b>'+dn+'</b> kargoya verilir · '+dd+'</span>');
        sl.hidden=false;
      } else sl.hidden=true;
    }
    upd();

    add.addEventListener('click',function(){
      if(!vcur||!vcur.available||add.classList.contains('is-busy')) return;
      add.classList.add('is-busy'); msg.hidden=true;
      var d=document.querySelector('cart-drawer'), q=Math.max(1,Math.min(99,parseInt(qi.value,10)||1));
      var bd={items:[{id:vcur.id,quantity:q}]};
      if(d&&d.renderContents){ bd.sections='cart-drawer,cart-icon-bubble'; bd.sections_url=window.location.pathname; }
      fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(bd)})
        .then(function(r){ return r.json(); })
        .then(function(j){
          add.classList.remove('is-busy');
          if(j.status){ msg.textContent=j.description||j.message||'Sepete eklenemedi.'; msg.hidden=false; return; }
          add.classList.add('is-done'); add.textContent='Sepete eklendi';
          setTimeout(function(){
            close();
            if(d&&d.renderContents&&j.sections){ d.classList.remove('is-empty'); d.renderContents(j); }
            else { window.location.href=ROOT+'cart'; return; }
            if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'mw-quick-view',cartData:j});
          },450);
        })
        .catch(function(){ add.classList.remove('is-busy'); msg.textContent='Bağlantı sorunu, tekrar dene.'; msg.hidden=false; });
    });
  }
})();}catch(e){setTimeout(function(){throw e;});}